import React, { useState, useEffect } from "react";

const ContactPageAdmin = () => {
  const [contactData, setContactData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);

  // Initialize with default values to prevent undefined errors
  const [formData, setFormData] = useState({
    title: "",
    subtitle: "",
    description: "",
    contactInfo: [], // Always initialize as empty array
    imageUrl: "",
    isActive: true,
  });

  // Fetch contact data
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch("https://imagetohtmlaiproject25-d0525ebf3976.herokuapp.com/api/contact-page");
        const result = await response.json();
        if (result.success) {
          setContactData(result.data);
          // Ensure contactInfo is always an array
          setFormData({
            title: result.data.title || "",
            subtitle: result.data.subtitle || "",
            description: result.data.description || "",
            contactInfo: Array.isArray(result.data.contactInfo)
              ? result.data.contactInfo
              : [],
            imageUrl: result.data.imageUrl || "",
            isActive:
              typeof result.data.isActive === "boolean"
                ? result.data.isActive
                : true,
          });
        }
        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching contact data:", error);
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  // Handle contact info changes
  const handleContactInfoChange = (index, field, value) => {
    // Ensure contactInfo exists and is an array
    const currentContactInfo = Array.isArray(formData.contactInfo)
      ? [...formData.contactInfo]
      : [];

    // Ensure the item exists
    if (!currentContactInfo[index]) {
      currentContactInfo[index] = {
        type: "phone",
        icon: "",
        value: "",
        label: "",
      };
    }

    currentContactInfo[index][field] = value;

    setFormData((prev) => ({
      ...prev,
      contactInfo: currentContactInfo,
    }));
  };

  // Add new contact info
  const addContactInfo = () => {
    setFormData((prev) => {
      const currentContactInfo = Array.isArray(prev.contactInfo)
        ? [...prev.contactInfo]
        : [];
      return {
        ...prev,
        contactInfo: [
          ...currentContactInfo,
          { type: "phone", icon: "fi fi-tr-phone-call", value: "", label: "" },
        ],
      };
    });
  };

  // Remove contact info
  const removeContactInfo = (index) => {
    setFormData((prev) => {
      const currentContactInfo = Array.isArray(prev.contactInfo)
        ? [...prev.contactInfo]
        : [];
      if (index >= 0 && index < currentContactInfo.length) {
        currentContactInfo.splice(index, 1);
      }
      return {
        ...prev,
        contactInfo: currentContactInfo,
      };
    });
  };

  // Submit form
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSaving(true);

    try {
      const response = await fetch("https://imagetohtmlaiproject25-d0525ebf3976.herokuapp.com/api/contact-page", {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();
      if (result.success) {
        alert("Contact page updated successfully!");
        setContactData(result.data);
      } else {
        alert("Failed to update contact page: " + result.message);
      }
    } catch (error) {
      console.error("Error updating contact page:", error);
      alert("Error updating contact page");
    } finally {
      setIsSaving(false);
    }
  };

  // Reset to default
  const handleReset = async () => {
    if (window.confirm("Are you sure you want to reset to default values?")) {
      try {
        const response = await fetch("https://imagetohtmlaiproject25-d0525ebf3976.herokuapp.com/api/contact-page/reset", {
          method: "POST",
        });

        const result = await response.json();
        if (result.success) {
          alert("Contact page reset to default successfully!");
          setContactData(result.data);
          setFormData({
            title: result.data.title || "",
            subtitle: result.data.subtitle || "",
            description: result.data.description || "",
            contactInfo: Array.isArray(result.data.contactInfo)
              ? result.data.contactInfo
              : [],
            imageUrl: result.data.imageUrl || "",
            isActive:
              typeof result.data.isActive === "boolean"
                ? result.data.isActive
                : true,
          });
        } else {
          alert("Failed to reset contact page: " + result.message);
        }
      } catch (error) {
        console.error("Error resetting contact page:", error);
        alert("Error resetting contact page");
      }
    }
  };

  if (isLoading) {
    return <div>Loading admin panel...</div>;
  }

  return (
    <div className="admin-panel container py-4">
      <h2>Contact Page Admin</h2>

      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label className="form-label">Title</label>
          <input
            type="text"
            className="form-control"
            name="title"
            value={formData.title || ""}
            onChange={handleInputChange}
            required
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Subtitle</label>
          <input
            type="text"
            className="form-control"
            name="subtitle"
            value={formData.subtitle || ""}
            onChange={handleInputChange}
          />
        </div>

        {/* <div className="mb-3">
          <label className="form-label">Description</label>
          <textarea
            className="form-control"
            name="description"
            value={formData.description || ""}
            onChange={handleInputChange}
            rows="3"
          />
        </div> */}

        <div className="mb-3">
          <label className="form-label">Image URL</label>
          <input
            type="text"
            className="form-control"
            name="imageUrl"
            value={formData.imageUrl || ""}
            onChange={handleInputChange}
          />
        </div>

        <div className="mb-3 form-check">
          <input
            type="checkbox"
            className="form-check-input"
            name="isActive"
            checked={formData.isActive || false}
            onChange={handleInputChange}
          />
          <label className="form-check-label">Active</label>
        </div>

        <div className="mb-3">
          {/* <label className="form-label">Contact Information </label> */}
          {Array.isArray(formData.contactInfo) &&
            formData.contactInfo.map((info, index) => (
              <div key={index} className="card mb-2">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-3">
                      <select
                        className="form-select"
                        value={info.type || "phone"}
                        onChange={(e) =>
                          handleContactInfoChange(index, "type", e.target.value)
                        }
                      >
                        <option value="phone">Phone</option>
                        <option value="email">Email</option>
                      </select>
                    </div>
                    <div className="col-md-3">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Icon class"
                        value={info.icon || ""}
                        onChange={(e) =>
                          handleContactInfoChange(index, "icon", e.target.value)
                        }
                      />
                    </div>
                    <div className="col-md-4">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Value"
                        value={info.value || ""}
                        onChange={(e) =>
                          handleContactInfoChange(
                            index,
                            "value",
                            e.target.value
                          )
                        }
                      />
                    </div>
                    <div className="col-md-2">
                      <button
                        type="button"
                        className="btn btn-danger"
                        onClick={() => removeContactInfo(index)}
                      >
                        Remove
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          <button
            type="button"
            className="btn btn-secondary"
            onClick={addContactInfo}
          >
            Add Contact Info
          </button>
        </div>

        <div className="d-flex gap-2">
          <button type="submit" className="btn btn-primary" disabled={isSaving}>
            {isSaving ? "Saving..." : "Save Changes"}
          </button>
          <button
            type="button"
            className="btn btn-outline-secondary"
            onClick={handleReset}
          >
            Reset to Default
          </button>
        </div>
      </form>
    </div>
  );
};

export default ContactPageAdmin;
